import React from 'react';
import styled from 'styled-components';

import 'slick-carousel/slick/slick.css';
import { Flex } from 'Components/Base';

const CarouselContainer = styled((props) => (
  <Flex className="carousel-default-container" {...props} />
))`
  position: relative;
  overflow: hidden;
  flex-direction: column;
  justify-content: space-between;
  height: 100%;

  .slick-slider {
    height: 100%;
  }

  .slick-list {
    overflow: visible;
    height: 100%;
  }
  .slick-track {
    height: 100%;
  }

  .slick-slide {
    height: 100%;
    div:first-child {
      display: flex;
      flex-direction: column;
      height: 100%;
    }
  }
`;

export default CarouselContainer;
